import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FeedbackService } from '../../service/feedback.service';

@Component({
    selector: 'app-feedback-dialog',
    templateUrl: './feedback-dialog.component.html',
    styleUrls: ['./feedback-dialog.component.scss'],
    standalone: false
})
export class FeedbackDialogComponent {
  feedbackForm: FormGroup;
  feedbackOptions: any[] = [];
  feedbackTypes = []; // ['Chat', 'Summarizer', 'Admin', 'History', 'Others']; // Replace with actual types
  hasChange = false;
  isSubmitted: boolean = false;
  constructor(
    private fb: FormBuilder,
    private feedbackService: FeedbackService,
    public dialogRef: MatDialogRef<FeedbackDialogComponent>
  ) {
    this.feedbackForm = this.fb.group({
      feedback_metadata_id: ['', Validators.required],
      app_feedback_description: ['', Validators.required],
      app_feedback_topic: ['', Validators.required],

      app_feedback_status: ['Active']
    });
  }

  ngOnInit(): void {
    this.feedbackService.getFeedbackOptions().subscribe(options => {
      this.feedbackOptions = options;
    });
    if (sessionStorage.getItem('role').toLowerCase() !== 'supervisor') {
      this.feedbackTypes = ['Chat', 'Summarizer', 'History', 'Others'];
    } else {
      this.feedbackTypes = ['Chat', 'Summarizer', 'Admin', 'History', 'Others'];
    }

    this.feedbackForm.valueChanges.subscribe(x => {
      this.hasChange = true;
    }); 
  }

  onSubmit(): void {
    this.hasChange = false;
    if (this.isSubmitted) {
      return; 
    }

    //this.isSubmitted = true;
    if (this.feedbackForm.invalid) {
      this.feedbackForm.markAllAsTouched();
      this.isSubmitted = false; 
      return; 
    }
    this.isSubmitted = true;
    this.feedbackService.saveFeedback(this.feedbackForm.value).subscribe(response => {   
      this.dialogRef.close(true); 
      this.isSubmitted = false; 
    }, error => {
      this.isSubmitted = false; 
    });
  
  }
  onCancel(): void {
    this.dialogRef.close();
  }
}
